
import BaseDropdown from "@/components/base/BaseDropdown.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import { countryList } from "@/config/countries";
import { DropdownOption } from "@/models/DropdownOption";
import { DirectionEnum } from "@/models/enums";
import { AddressInformationState } from "@/models/www/store/BookingState";
import { useBookingStore } from "@/store/booking";
import { defineComponent } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { computed, reactive, watch } from "vue";

	export default defineComponent({
		components: {
            BaseSection,
            BaseInput,
            BaseDropdown
		},	
        setup() {
            const bookingStore = useBookingStore();

            const leadPass = computed(() => {
                const id = bookingStore.getBooking.leadPassengerId;
                const passengers = bookingStore.getPassengers(DirectionEnum.Outward);

                //if no lead pass exist, set first passenger as default lead passenger
                return passengers.find(p => p.nameListId === id) ?? passengers[0];
            });

            const addressInformation = computed(() => bookingStore.getBooking.addressInformation);

            const passengers = computed(() => {
                const options = [] as DropdownOption[];
                const statePassengers = bookingStore.getBooking.outward.passengers;

                statePassengers.forEach((passenger, index) => {
                    if(passenger.firstName) {
                        options.push({ label: `${passenger.firstName} ${passenger.lastName}`, value: passenger.nameListId });
                    }
                });

                return options;
            });

            const state = reactive({
                leadPassenger: leadPass.value?.nameListId ?? "",
                mobilePhone: addressInformation.value?.mobilePhone ?? "",
                postCode: addressInformation.value?.postCode ?? "",
                city: addressInformation.value?.city ?? "",
                address: addressInformation.value?.address ?? "",
                countryCode: addressInformation.value?.countryCode ?? countryList[0].value
            });

            const rules = {
                leadPassenger: { required },
                mobilePhone: { required },
                postCode: { required },
                address: { required },
                city: { required },
                countryCode: { required }
            }

            const v$ = useVuelidate(rules, state);   

            watch(
                (state),
                () => {
                    const stateIsValid = Object.values(state).every(x => x !== null && x !== '');
                    const passenger = bookingStore.getPassengers(DirectionEnum.Outward).find(p => p.nameListId === state.leadPassenger)

                    if(stateIsValid && passenger) {
                        bookingStore.setLeadPassenger(passenger.nameListId);

                        bookingStore.setAddressInformation({
                            mobilePhone: state.mobilePhone,
                            postCode: state.postCode,
                            address: state.address,
                            city: state.city,
                            countryCode: state.countryCode
                        } as AddressInformationState);
                    }
                }
            );
            
            return { passengers, countryList, v$ };
        }
	});
